import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <div className="banner-section">
            <h2>TRAVEL CO </h2>
            <h4>Your Journey Begins</h4>
            <p>A journey of a 1000 miles starts with a single step. <br/>
            Treat yourself with a journey to your inner self.
            We promise, you’ll enjoy every step you make.
            </p>
        </div>
    );
};

export default Banner;